import React from "react";
import SuccessPage from "components/success-page";

const FastTrackPurchaseSuccess = () => {
  return (
    <SuccessPage
      title="Felicidades!"
      description="Has comprado Fast-Track y serás candidato prioritario."
      cta="Continuar"
      asset="/icons/fast-track/fast-track-profile-card.svg"
    />
  );
};

export default FastTrackPurchaseSuccess;
